/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import { API_HOST, API_PATH } from "@/src/config/_entrypoint";
import downloadTileStyle from "./downloadTileStyle";
import { Box, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { MediaObject } from "@/src/types/Entities/MediaObject/MediaObject";
import { Link } from "react-router";
import { DescriptionOutlined, FileDownloadOutlined } from "@mui/icons-material";

type DownloadTileProps = {
  mediaObject: MediaObject;
};

const DownloadTile = ({ mediaObject }: DownloadTileProps) => {
  const downloadLink = API_HOST + API_PATH + "/download/" + mediaObject.id + "?token=" + localStorage.getItem("token");
  // TODO: Check if this api endpoint can be deactivated const downloadLink const bgImage = "url(" + downloadLink + "&thumbNail=1)";

  return (
    <>
      <Stack component={Link} download to={downloadLink} direction={"row"} sx={downloadTileStyle.container} spacing={2}>
        <DescriptionOutlined fontSize={"large"} />
        <Box
          sx={(theme) => ({
            color: theme.palette.text.primary,
            flexGrow: 1,
          })}
        >
          <Typography component={"div"} variant={"body2"}>
            <strong>{mediaObject.description}</strong>
          </Typography>
        </Box>
        <FileDownloadOutlined fontSize={"large"} />
      </Stack>
    </>
  );
};

export default DownloadTile;
